var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesOptizmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.375V17.4375",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 12.375L13.5 17.4375L18.5625 12.375",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 19.6875V21.9375C4.21875 22.2361 4.33736 22.5225 4.54854 22.7336C4.75972 22.9448 5.0461 23.0625 5.34375 23.0625H21.6562C21.9539 23.0625 22.2403 22.9448 22.4515 22.7336C22.6626 22.5225 22.7812 22.2361 22.7812 21.9375V19.6875",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesOptizmo);
export default __webpack_public_path__ + "static/media/pipelines-optizmo.05e90656e1f68c5c3ef3d961afde483c.svg";
export { ForwardRef as ReactComponent };